import styled from '@emotion/styled';
import { Flex } from '../../../../ui';

export const DialogActions = styled(Flex)`
	justify-content: ${({ justifyContent }) => justifyContent ?? 'space-between'};
	margin: 32px 0 16px;
`;
